const qs = require('querystringify');
let lang = 'en';
let langMap = {
  en: require('../lang/en.json'),
  zh: require('../lang/zh.json'),
  zh_tw: require('../lang/zh_tw.json')
};

let query = qs.parse(window.location.search);
// 优先根据url中的lang字段判断语言，其次根据sessionStorage
if (query.lang) {
  if (Object.keys(langMap).indexOf(query.lang) > -1) {
    lang = query.lang;
    sessionStorage.setItem('lang', lang);
  }
} else {
  let store_lang = sessionStorage.getItem('lang');
  if (Object.keys(langMap).indexOf(store_lang) > -1) {
    lang = store_lang;
  }
}
function getLang(key) {
  let data = langMap[lang];
  if (!data[key]) {
    console.error(`${key} in not exist in data`);
    return key;
  } else {
    return data[key];
  }
}

export { getLang, lang };
